import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthLayoutRoutes } from '../navigation-services/auth-layout-routes.service';
import { AuthService } from './authservice.service';

@Injectable({
  providedIn: 'root'
})
export class AuthguardService  {
  
  constructor(private router: Router, private auth: AuthService, private authRoute: AuthLayoutRoutes) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.authChecker(state);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.authChecker(state);
  }

  authChecker(state: RouterStateSnapshot): boolean {
    if (this.auth.token != null && this.auth.token!=='') { 
      return true;
    } else {
      this.authRoute.navigateToLogin();
      return false;
    }
  }
}
